import { Link } from "react-router-dom";
import { ChatCircleDots } from "@phosphor-icons/react";
import ConversationRow from "./ConversationRow";

function LoadingState() {
  return (
    <div className="bg-white/55 backdrop-blur-md rounded-[28px] border border-white/60 shadow-[0_2px_18px_rgba(10,25,47,0.08)] py-12 text-center text-[#5A6470] text-sm">
      جارٍ التَّحميل…
    </div>
  );
}

function EmptyState() {
  return (
    <div
      className="bg-white/55 backdrop-blur-md rounded-[28px] border border-white/60 shadow-[0_2px_18px_rgba(10,25,47,0.08)] mt-10 text-center px-6 py-10"
      data-testid="messages-empty"
    >
      <div className="mx-auto w-20 h-20 rounded-full bg-gradient-to-br from-[#F0C97E] to-[#B8860B] flex items-center justify-center shadow-[0_8px_24px_rgba(212,175,55,0.35)] mb-5">
        <ChatCircleDots size={36} weight="fill" className="text-white" />
      </div>
      <div className="font-bold text-[16px] text-[#0A192F] mb-1.5">لا توجد مُحادثات بَعد</div>
      <div className="text-[13px] text-[#5A6470] leading-relaxed mb-6">
        ابدأ مُحادثة من صَفحة أيّ مُحامٍ عَبر زر <b>«مُحادثة داخل التطبيق»</b>،
        أو شارِك مَلَفّك مع عُملائك لِيَتواصلوا معك مُباشرَةً.
      </div>
      <Link
        to="/"
        className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-full bg-[#0A192F] text-white text-[13px] font-bold active:scale-95 transition"
        data-testid="messages-empty-cta"
      >
        ابحث عن مُحامٍ
      </Link>
    </div>
  );
}

// Loading / empty / no-matches / list — decides which state to render.
export default function ConversationList({
  loading, items, filtered, myId, typingByConv, onSelect, onRequestDelete,
}) {
  if (loading) return <LoadingState />;
  if (items.length === 0) return <EmptyState />;
  if (filtered.length === 0) {
    return (
      <div className="bg-white/55 backdrop-blur-md rounded-[28px] border border-white/60 py-8 text-center text-[#8A8A8A] text-[13px]">
        لا توجد نَتائج لِبحثك.
      </div>
    );
  }
  return (
    <ul className="space-y-2.5">
      {filtered.map((c) => (
        <ConversationRow
          key={c.id}
          conv={c}
          myId={myId}
          isTyping={!!typingByConv?.[c.id]}
          onSelect={onSelect}
          onRequestDelete={onRequestDelete}
        />
      ))}
    </ul>
  );
}
